import React, { useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { useQuery, useMutation } from "@apollo/client";
import { format } from "date-fns";

import {
  Breadcrumbs,
  Typography,
  Box,
  Paper,
  Card,
  CardHeader,
  CardContent,
  CardMedia,
  ListItem,
  ListItemText,
  CardActions,
  Button,
  Modal,
  Alert,
  Divider,
} from "@mui/material";
import {
  DELETE_SUB_PACKAGE,
  SUB_PACKAGE_BY_PK,
} from "../../gql/subscriptionPakcage";
import SubscriptionPakcageVariants from "../subscriptionPakcagesVariant/SubscriptionPakcageVariants";
import { LoadingModal } from '../../components/layout';

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "100vw",
  height: "100vh",
  overflow: "scroll",
  bgcolor: "background.paper",
  // border: "2px solid #000",
  boxShadow: 24,
};
const styleR = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const SubscriptionPackage = ({ homeAlert }) => {
  const navigate = useNavigate();
  const { id } = useParams();

  const result = useQuery(SUB_PACKAGE_BY_PK, { variables: { id: id } });
  const [showAlert, setShowAlert] = useState({ message: "", isError: false });
  const [openU, setOpenU] = useState(false);
  const [openR, setOpenR] = useState(false);
  console.log("result ", result);
  const sub_packageAlert = (message, isError = false) => {
    setShowAlert({ message: message, isError: isError });
    setTimeout(() => {
      setShowAlert({ message: "", isError: false });
    }, 3000);
  };

  const [deleteBlog] = useMutation(DELETE_SUB_PACKAGE, {
    onError: (error) => {
      console.log(error);
      setShowAlert({ message: "Error on server", isError: true });
      setTimeout(() => {
        setShowAlert({ message: "", isError: false });
      }, 3000);
    },
    onCompleted: () => {
      alert("Subscrption Package has been removed");
      navigate(-1);
    },
  });

  if (result.loading) {
    return <LoadingModal open message="Loading..." />;
  }

  const handleOpenU = () => setOpenU(true);
  const handleCloseU = () => setOpenU(false);
  const handleOpenR = () => setOpenR(true);
  const handleCloseR = () => setOpenR(false);

  const sub_package = result?.data?.subscription_packages_by_pk;
  console.log("subpakage ", sub_package);
  const handleDelete = () => {
    // let image_url = sub_package.title_image_url;
    // let image_name = image_url.substring(
    //   image_url.lastIndexOf("/") + 1,
    //   image_url.lenght
    // );
    deleteBlog({ variables: { id: sub_package.id } });
  };

  return (
    <div>
      <div role="presentation">
        <Breadcrumbs aria-label="breadcrumb">
          <Link to="/user" className="dashboard">
            Dashboard
          </Link>
          <Link to="/sub_package" className="dashboard">
            Subscription Package
          </Link>
          <span>{id}</span>
        </Breadcrumbs>
      </div>
      <Typography variant="h6" component="h2" sx={{ my: 3, color: "black" }}>
        Subscription Package Details
      </Typography>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "1fr 1.2fr" },
          gap: 3,
          mb: 2.5,
          alignItems: "start",
        }}
      >
        {/* Left Column: Key Information Card */}
        <Card sx={{ borderRadius: "12px", border: "1px solid #eee", boxShadow: "0 1px 4px rgba(0, 0, 0, 0.04)", p: 2 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1, px: 2 }}>
            Key Information
          </Typography>
          <Divider />
          <Box sx={{ mt: 1 }}>
            <ListItem>
              <ListItemText primary="ID" secondary={sub_package?.id} />
            </ListItem>
            <ListItem>
              <ListItemText primary="Title" secondary={sub_package?.title} />
            </ListItem>
            <ListItem>
              <ListItemText
                primary="Created At"
                secondary={
                  sub_package?.created_at &&
                  format(new Date(sub_package.created_at), "yyyy-MM-dd hh:mm:ss a")
                }
              />
            </ListItem>
          </Box>
        </Card>

        {/* Right Column: Descriptions */}
        <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
          <Card sx={{ borderRadius: "12px", border: "1px solid #eee", boxShadow: "0 1px 4px rgba(0, 0, 0, 0.04)", p: 2 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1, px: 2 }}>
              Description
            </Typography>
            <Divider />
            <Box sx={{ mt: 2, display: "flex", flexDirection: "column", gap: 2 }}>
              {sub_package?.description_en && (
                <Box>
                  <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>
                    ENGLISH
                  </Typography>
                  <Box sx={{ p: 2, mt: 0.5, bgcolor: "#f7f7f5", borderRadius: 2 }}>
                    <Typography variant="body2" color="text.secondary" component="div">
                      {sub_package.description_en.map((m, idx) => (
                        <React.Fragment key={idx}>
                          {m} <br />
                        </React.Fragment>
                      ))}
                    </Typography>
                  </Box>
                </Box>
              )}
              {sub_package?.description_mm && (
                <Box>
                  <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>
                    MYANMAR
                  </Typography>
                  <Box sx={{ p: 2, mt: 0.5, bgcolor: "#f7f7f5", borderRadius: 2 }}>
                    <Typography variant="body2" color="text.secondary" component="div">
                      {sub_package.description_mm.map((m, idx) => (
                        <React.Fragment key={idx}>
                          {m} <br />
                        </React.Fragment>
                      ))}
                    </Typography>
                  </Box>
                </Box>
              )}
            </Box>
          </Card>
        </Box>
      </Box>
      <SubscriptionPakcageVariants packageId={id} />
      {/* <Modal
        keepMounted
        open={openR}
        onClose={handleCloseR}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <Box sx={styleR}>
          <Typography id="keep-mounted-modal-title" variant="h6" component="h2">
            Confirmation
          </Typography>
          <Typography id="keep-mounted-modal-description" sx={{ mt: 2 }}>
            Are you sure want to remove this sub_package?
          </Typography>
          <Box sx={{ textAlign: "right", mt: 2 }}>
            <Button color="secondary" onClick={handleCloseR}>
              Cancel
            </Button>
            <Button onClick={handleDelete}>Confirm</Button>
          </Box>
        </Box>
      </Modal> */}
      <div style={{ minHeight: "auto" }}>
        {/* <Modal
          open={openU}
          onClose={handleCloseU}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          sx={{ width: "100vw" }}
        >
          <Box sx={style}>
            <UpdateBlog
              sub_package={sub_package}
              // handleClose={handleCloseU}
              // sub_packageAlert={sub_packageAlert}
            />
          </Box>
        </Modal> */}
      </div>
      {showAlert.message && !showAlert.isError && (
        <Alert
          sx={{ position: "fixed", bottom: "1em", right: "1em" }}
          severity="success"
        >
          {showAlert.message}
        </Alert>
      )}
      {showAlert.message && showAlert.isError && (
        <Alert
          sx={{ position: "fixed", bottom: "1em", right: "1em" }}
          severity="warning"
        >
          {showAlert.message}
        </Alert>
      )}
    </div>
  );
};

export default SubscriptionPackage;
